module.exports = __webpack_public_path__ + "resources/img/item1.1f41839b.svg";